export const COLLABORATION_DESI_ALL = 'COLLABORATION_DESI_ALL';
export const COLLABORATION_FILTER_SUCCESS = 'COLLABORATION_FILTER_SUCCESS';
export const COLLABORATION_DESI_SINGLE = 'COLLABORATION_DESI_SINGLE';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const COLLABORATION_DESI_LIST_SUCCESS =
  'COLLABOARTION_DESI_LIST_SUCCESS';
